import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getSlots = (date) => api.get(`/slots`, { params: { date } });
export const createBooking = (payload) => api.post(`/bookings`, payload);
export const getBookingsByPhone = (phone) =>
  api.get(`/bookings/by-phone`, { params: { phone } });

export const adminLogin = (password) => api.post(`/admin/login`, { password });
export const adminListBookings = (token, params = {}) =>
  api.get(`/admin/bookings`, {
    headers: { "X-Admin-Password": token },
    params,
  });
export const adminUpdateBooking = (token, id, status) =>
  api.patch(
    `/admin/bookings/${id}`,
    { status },
    { headers: { "X-Admin-Password": token } }
  );
export const adminStats = (token) =>
  api.get(`/admin/stats`, { headers: { "X-Admin-Password": token } });
